// CS 21.55 — ASHTH LITE badge. Rendered next to product identity anywhere
// an operator would question the pricing basis (catalog cards, list
// rows, reports). Compact, high-contrast, unmistakable.
import React from "react";
import { Zap } from "lucide-react";
import { isAlEffective } from "@/lib/ashthLite";

export function AshthLiteBadge({ product, size = "sm", className = "" }) {
  // CS 21.83 (v5) — badge follows the canonical EFFECTIVE decision so a
  // manually tagged non-AL-code product shows the badge and the final-price
  // treatment together (never one without the other).
  if (!isAlEffective(product)) return null;
  const sizeCls =
    size === "xs"
      ? "text-[9px] px-1.5 py-[2px] gap-0.5"
      : size === "md"
      ? "text-[11px] px-2.5 py-1 gap-1.5"
      : "text-[10px] px-2 py-[3px] gap-1";
  return (
    <span
      data-testid={`ashth-lite-badge-${product?.jewel_code || product?.product_code || ""}`}
      title="Priced via Distribution Rate Settings (ASHTH LITE)"
      className={
        "inline-flex items-center uppercase tracking-wider rounded-full border " +
        "border-[#C9A84C] bg-[#FFF7E2] text-[#8A5A00] font-medium " +
        `whitespace-nowrap ${sizeCls} ${className}`
      }
    >
      <Zap className={size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3"} />
      ASHTH LITE
    </span>
  );
}
